import { observer } from "mobx-react-lite"
import { useStores } from "../../../models/helpers/useStores"
import styles from "./styles.module.scss"
import PersonOutline from "~icons/eva/person-outline"
import classNames from "classnames"

const avatarSizes = {
  sm: 32,
  md: 48,
  lg: 64,
  "3xl": 150,
}

export const UserAvatar = observer(function UserAvatar({
  size = "lg",
  customSize,
  avatar,
  nameInitals,
  userId,
  fontSize = "14px",
  isPrimary = true,
  ...rest
}: {
  size?: keyof typeof avatarSizes
  customSize?: number
  avatar?: string | null
  nameInitals?: string
  userId?: string | null
  fontSize?: string
  isPrimary?: boolean
}) {
  const { loggedInUser } = useStores()

  if (!loggedInUser) return

  const avatarImage = userId === loggedInUser.id ? loggedInUser.avatar : avatar
  const elementStyle = customSize
    ? { width: customSize, height: customSize }
    : { width: avatarSizes[size], height: avatarSizes[size] }

  if (userId === null) {
    return (
      <div
        className={classNames(styles.avatarWrapper, styles.avatarWrapperGuest)}
        style={elementStyle}
        {...rest}
      >
        <PersonOutline className={classNames(styles.avatarIcon, styles[size])} />
      </div>
    )
  }

  if (avatarImage) {
    return (
      <div className={styles.avatarImageContainer} style={elementStyle}>
        <img
          src={avatarImage as string}
          alt="User Avatar"
          className={styles.avatarImage}
          style={elementStyle}
        />
      </div>
    )
  }

  const userInitials =
    userId === loggedInUser.id
      ? `${loggedInUser.firstName[0]}${loggedInUser.lastName[0]}`
      : nameInitals || ""

  return (
    <div
      className={classNames(
        styles.avatarWrapper,
        isPrimary ? styles.avatarWrapperUser : styles.avatarWrapperGuest,
      )}
      style={elementStyle}
      {...rest}
    >
      <span className={styles.avatarInitials} style={{ fontSize }}>
        {userInitials.toUpperCase()}
      </span>
    </div>
  )
})

export default UserAvatar
